module.exports = __webpack_public_path__ + "static/racism-b6c75642afa16bee1856400faae4113d.png";